var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopFilled = function SvgStopFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70,76 L26,76 C22.687,76 20,73.313 20,70 L20,26 C20,22.687 22.687,20 26,20 L70,20 C73.313,20 76,22.687 76,26 L76,70 C76,73.313 73.313,76 70,76",
    fillRule: "evenodd"
  })));
};
export default SvgStopFilled;